import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getBranchesByTenant = createWrappedAsyncThunk(
  "branch/getBranchesByTenant",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`branches`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  }
);

export const saveBranch = createWrappedAsyncThunk(
  "branch/saveBranch",
  async (payload) => {
    return await httpClient.post(`branch`, payload);
  }
);

export const editBranch = createWrappedAsyncThunk(
  "branch/editBranch",
  async (payload) => {
    return await httpClient.put(`branch`, payload);
  }
);

export const getBranchesUsers = createWrappedAsyncThunk(
  "branch/getBranchesUsers",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`advisors`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  }
);

export const saveAdvisors = createWrappedAsyncThunk(
  "branch/saveAdvisors",
  async (payload) => {
    //@ts-ignore
    const { data, message } = await httpClient.post(`advisors`, payload);

    return { tenant_id: payload?.tenant_id, data, message };
  }
);

export const deleteAdvisor = createWrappedAsyncThunk(
  "branch/deleteAdvisor",
  async (payload) => {
    //@ts-ignore
    const { message } = await httpClient.delete(`advisors`, {
      data: payload,
    });

    return { ...payload, message };
  }
);
